import React from 'react';
import './ControlButtons.css';
import { useTheme } from '../../contexts/ThemeContext';
import { useSound } from '../../hooks/useSound';

const ControlButtons = ({
                            isRunning,
                            onStart,
                            onPause,
                            onReset,
                            onResetAndStart,
                            onPrev,
                            onNext,
                            onToggleSettings
                        }) => {
    const { darkMode, toggleDarkMode } = useTheme();
    const { muted, toggleMute } = useSound();

    return (
        <div className="control-buttons">
            <div className="button-row">
                <button className="reset-start-btn" onClick={onResetAndStart}>Start od nowa</button>
            </div>

            <div className="button-row">
                {!isRunning ? (
                    <button className="start-btn" onClick={onStart}>Start</button>
                ) : (
                    <button className="pause-btn" onClick={onPause}>Pauza</button>
                )}

                <button className="reset-btn" onClick={onReset}>Reset</button>
            </div>

            <div className="button-row">
                <button className="prev-btn" onClick={onPrev}>← Wstecz</button>
                <button className="next-btn" onClick={onNext}>Dalej →</button>
            </div>

            <div className="button-row">
                <button
                    className="theme-btn"
                    onClick={toggleDarkMode}
                >
                    {darkMode ? '☀️ Jasny' : '🌙 Ciemny'}
                </button>

                <button
                    className="mute-btn"
                    onClick={toggleMute}
                >
                    {muted ? '🔇 Włącz dźwięk' : '🔊 Wycisz'}
                </button>
            </div>

            <div className="button-row">
                <button
                    className="settings-btn full-width"
                    onClick={onToggleSettings}
                >
                    ⚙️ Ustawienia
                </button>
            </div>
        </div>
    );
};

export default ControlButtons;